import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "PaymentError",
    component: () => (__SERVER__ ? require("./payment-error-view") : import("./payment-error-view"))
});

export default definition;
